import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import StoreContext from "./../../../Store/Context";
import { Row, Col, Button, Container } from "reactstrap";
import { getStudentByParents } from "./../../Constants/Services";

interface IStudent {
  per_id: string;
  per_name: string;
  per_status: string;
  gr_id: string;
  gr_desc: string;
}

interface ILobbyState {
  dataStudent: IStudent[];
}

class Lobby extends Component<RouteComponentProps<{}>, ILobbyState> {
  static contextType = StoreContext;
  constructor(props: any) {
    super(props);
    this.state = {
      dataStudent: [],
    };
    this.fetchStudent = this.fetchStudent.bind(this);
    this.handlerSetStudent = this.handlerSetStudent.bind(this);
    this.handlerSetTeacher = this.handlerSetTeacher.bind(this);
  }

  async fetchStudent() {
    const response = await getStudentByParents(this.context.per_id);
    this.setState({
      dataStudent: response,
    });
  }

  handlerSetStudent(per_id) {
    const test = this.context;
    test.setUsrType({usr_type:"/parents",per_std:per_id})
    // test.setStd({ per_std: per_id });
    this.props.history.push("/parents/home");
  }

  handlerSetTeacher() {
    this.context.setAllow({allow:true});
    this.props.history.push(this.context.usr_type+"/home");
  }

  componentDidMount() {
    this.fetchStudent();
  }

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        <Container fluid={true}>
          <Row>
            <Col xs={12}>
              <Row>
                {this.context.usr_type.replace(/\//g, "") === "parents" && <React.Fragment>
                <Col xs={12} className="text-center mt-5">
              <h4 className="font-weight-bold">Estudiantes</h4>
            </Col>
                {props.dataStudent.map((data, i) => (
                  <Col xs={6} sm={4} key={data.per_id}>
                    <Button color="primary" className="mt-2 mb-2 w-100 box-h-90px" onClick={() => this.handlerSetStudent(data.per_id)}>
                      {`${data.per_name} - ${data.gr_desc} `}
                    </Button>
                  </Col>
                ))}
                  </React.Fragment>}

                  {this.context.usr_type.replace(/\//g, "") === "teachers" && <React.Fragment>
                  <Col xs={12} className="text-center mt-5">
              <h4 className="font-weight-bold">Profesor</h4>
            </Col>
                                 <Col xs={6} sm={4} >
                <Button color="success" className="mt-2 mb-2 w-100 box-h-90px" onClick={() => this.handlerSetTeacher()}>
                  Entrar como profesor
                </Button>
                </Col>
                {props.dataStudent.map((data, i) => (
                  <Col xs={6} sm={4} key={data.per_id}>
                    <Button color="primary" className="mt-2 mb-2 w-100 box-h-90px" onClick={() => this.handlerSetStudent(data.per_id)}>
                      {`${data.per_name} - ${data.gr_desc} `}
                    </Button>
                  </Col>
                ))}
                  </React.Fragment>}

              </Row>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Lobby;
